
__webpack_require__.debugRequireIds = {
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/google-sprite.css": 17171,
	"!!../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/cjs.js!./generated/emoji-styles/twitter-sprite.css": 86161,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/google-sprite.css": 4736,
	"!style-loader?injectType=lazyStyleTag!css-loader!./generated/emoji-styles/twitter-sprite.css": 14124,
	"-!./debug-require.cjs": 2800,
	"./debug-require.cjs": 90694,
	"./generated/emoji/google.webp": 94213,
	"./generated/emoji/twitter.webp": 60889,
	"./src/base_page_params.ts": 46836,
	"./src/blueslip.ts": 25878,
	"./src/blueslip_stacktrace.ts": 16968,
	"./src/bot_types.ts": 51157,
	"./src/bundles/common.ts": 98683,
	"./src/csrf.ts": 90186,
	"./src/i18n.ts": 80908,
	"./src/portico/google-analytics.ts": 21123,
	"./src/portico/portico_modals.ts": 33154,
	"./src/portico/tippyjs.ts": 57596,
	"./src/realm_user_settings_defaults.ts": 98676,
	"./src/sentry.ts": 29479,
	"./src/state_data.ts": 74710,
	"./src/stream_types.ts": 92666,
	"./src/types.ts": 6279,
	"./src/user_settings.ts": 23175,
	"./src/user_status_types.ts": 16638,
	"./src/util.ts": 35796,
	"./templates/blueslip_stacktrace.hbs": 84856,
	"@formatjs/fast-memoize": 96140,
	"altcha": 26971,
	"core-js/modules/es.array-buffer.detached.js": 29995,
	"core-js/modules/es.array-buffer.transfer-to-fixed-length.js": 550,
	"core-js/modules/es.array-buffer.transfer.js": 28754,
	"core-js/modules/es.array.push.js": 4356,
	"core-js/modules/es.iterator.constructor.js": 7913,
	"core-js/modules/es.iterator.filter.js": 94879,
	"core-js/modules/es.iterator.find.js": 60578,
	"core-js/modules/es.iterator.map.js": 61615,
	"core-js/modules/es.iterator.some.js": 63305,
	"core-js/modules/es.json.parse.js": 34478,
	"core-js/modules/es.json.stringify.js": 17904,
	"core-js/modules/es.map.get-or-insert-computed.js": 9537,
	"core-js/modules/es.map.get-or-insert.js": 36561,
	"core-js/modules/es.set.difference.v2.js": 41952,
	"core-js/modules/es.set.intersection.v2.js": 30142,
	"core-js/modules/es.set.is-disjoint-from.v2.js": 31863,
	"core-js/modules/es.set.is-subset-of.v2.js": 31790,
	"core-js/modules/es.set.is-superset-of.v2.js": 49173,
	"core-js/modules/es.set.symmetric-difference.v2.js": 64618,
	"core-js/modules/es.set.union.v2.js": 39796,
	"core-js/modules/es.typed-array.with.js": 95747,
	"core-js/modules/es.uint8-array.set-from-base64.js": 82474,
	"core-js/modules/es.uint8-array.set-from-hex.js": 94188,
	"core-js/modules/es.uint8-array.to-base64.js": 82140,
	"core-js/modules/es.uint8-array.to-hex.js": 45342,
	"core-js/modules/web.url-search-params.delete.js": 17361,
	"core-js/modules/web.url-search-params.has.js": 46860,
	"core-js/modules/web.url-search-params.size.js": 27351,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 81942,
	"jquery": 63150,
	"jquery-validation": 9905,
	"lodash": 96749,
	"micromodal": 98476,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 71376,
	"zod/mini": 15729
};